import { render, staticRenderFns } from "./BuilderCheckBox.vue?vue&type=template&id=106e2473&"
import script from "./BuilderCheckBox.vue?vue&type=script&lang=js&"
export * from "./BuilderCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports